import React from "react";
import { stripNamespacePrefix as stripPrefix } from "../../../utils/nameUtils";

export default function SceneGraphReparentBodyList({
  groupedParentOptions,
  bodies,
  onSelectBody,
  filterBody = (body) => body?.uuid,
}) {
  const renderBodyButton = (body) => (
    <button
      key={body.uuid}
      type="button"
      onClick={() => onSelectBody(body.uuid)}
      className="w-full text-left rounded-sm px-2 py-1.5 text-sm text-gray-200 hover:bg-gray-700/90 transition-colors"
    >
      {stripPrefix(body.name)}
    </button>
  );

  return (
    <div className="max-h-48 overflow-y-auto space-y-0.5">
      {groupedParentOptions
        ? groupedParentOptions.map((group) => (
            <div key={group.label}>
              <div className="px-2 py-1 text-[10px] font-semibold text-gray-400 uppercase tracking-wide">
                {group.label}
              </div>
              {group.bodies.map(renderBodyButton)}
            </div>
          ))
        : Object.values(bodies || {})
            .filter(filterBody)
            .sort((a, b) =>
              String(stripPrefix(a.name) || "").localeCompare(String(stripPrefix(b.name) || ""))
            )
            .map(renderBodyButton)}
    </div>
  );
}
